// src/admin/pages/Restaurants/MenuList.js
import React from "react";
import "./MenuList.css";

export default function MenuList({
  menus,
  selectedMenu,
  onSelectMenu,
  onMenuUpdated,
}) {
  const toggleMenuActive = async (menu, e) => {
    e.stopPropagation();
    try {
      const token = localStorage.getItem("access_token");
      const newActive = !menu.active;

      const res = await fetch(`${process.env.REACT_APP_API_URL}/menus/${menu.id}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ active: newActive }),
      });
      if (!res.ok) {
        const errData = await res.json();
        throw new Error(errData.detail || "Errore aggiornamento menù");
      }
      const updatedMenu = await res.json();
      onMenuUpdated(updatedMenu);
    } catch (err) {
      console.error("Errore toggleMenuActive:", err);
      alert(err.message);
    }
  };

  if (!menus || menus.length === 0) {
    return <p className="no-menus-text">Nessun menù disponibile.</p>;
  }

  return (
    <div className="menu-list">
      {menus.map((menu) => {
        const isSelected = selectedMenu && selectedMenu.id === menu.id;
        return (
          <div
            key={menu.id}
            className={`menu-card ${isSelected ? "selected" : ""}`}
            onClick={() => onSelectMenu(menu)}
          >
            <div className="menu-card-header">
              <strong>{menu.name}</strong>
              {!menu.active && <span className="inactive-label">(Inattivo)</span>}
            </div>
            <div
              className="toggle-active-icon"
              title={menu.active ? "Disattiva menù" : "Riattiva menù"}
              onClick={(e) => toggleMenuActive(menu, e)}
            >
              {/* Icona a piacere, qui usiamo un’emoji come esempio */}
              {menu.active ? "🟢" : "🔴"}
            </div>
          </div>
        );
      })}
    </div>
  );
}
